import { render, staticRenderFns } from "./ContentViewSettingsLabels.vue?vue&type=template&id=03d4c23a&scoped=true&"
import script from "./ContentViewSettingsLabels.vue?vue&type=script&lang=js&"
export * from "./ContentViewSettingsLabels.vue?vue&type=script&lang=js&"
import style0 from "./ContentViewSettingsLabels.vue?vue&type=style&index=0&id=03d4c23a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d4c23a",
  null
  
)

export default component.exports